import styled from 'styled-components'

const Section = styled.section`
  background-color: #002244; /* Dark blue background */
  color: white;
  padding: 40px 100px;
  text-align: center;
`

const Subhead = styled.h2`
  font-size: 28px;
  margin-bottom: 40px;
`

const TileGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

const Tile = styled.div`
  background-color: white; /* Grey background */
  border-radius: 10px;
  padding: 20px;
  min-height: 320px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const TileNumber = styled.div`
  background-color: white;
  color: #002244; /* Dark blue foreground */
  border-radius: 50%;
  width: 2em;
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5em;
  margin-bottom: 10px;
  border-color: #002244;
  border: 1px solid;
  line-height: 2em;
  padding-top: 2px;
`

const TileSubhead = styled.h3`
  font-size: 20px;
  margin-bottom: 10px;
  color: #002244;
`

const TileBodyText = styled.p`
  font-size: 16px;
  color: #002244;
`

const LearnMoreLink = styled.a`
  display: inline-block;
  margin-top: 10px;
  color: #002244;
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
  &:hover {
    text-decoration: none;
  }
`

interface TileComponentProps {
  number: number
  subhead: string
  bodyText: string
  link?: string
}

const TileComponent: React.FC<TileComponentProps> = ({ number, subhead, bodyText, link }) => (
  <Tile>
    <div>
      <TileNumber>{number}</TileNumber>
      <TileSubhead>{subhead}</TileSubhead>
      <TileBodyText>{bodyText}</TileBodyText>
    </div>
    {link && <LearnMoreLink href={link}>Learn More</LearnMoreLink>}
  </Tile>
)

const HowItWorksSection = () => (
  <Section>
    <Subhead>How It Works</Subhead>
    <TileGrid>
      <TileComponent
        number={1}
        subhead="Discover your savings"
        bodyText=" Schedule a brief call to learn your potential rebate amount based on your location
                  and price range. Many buyers are surprised by how much they can get back."
      />
      <TileComponent
        number={2}
        subhead="Sign a buyer agreement"
        bodyText="Sign a Buyer Agreement to get started. A Buyer Agreement is now mandated by the
                  National Association of Realtors before a showing."
      />
      <TileComponent
        number={3}
        subhead="Find your new home"
        bodyText="Your dedicated team will take you to properties that match your criteria. Custom,
                  personalized search alerts will ensure you never miss an ideal listing."
      />
      <TileComponent
        number={4}
        subhead="Craft a stronger offer"
        bodyText="Use your commission rebate as a negotiation tool. In a competitive situation, you
                  can reduce the buyer commission to strengthen your offer while still getting the
                  property you want. Your agent will help you structure the deal to maximize your
                  savings without sacrificing competitiveness."
        link="https://homerise.com/buy/#net-effective"
      />
      <TileComponent
        number={5}
        subhead="Newfound Title"
        bodyText="Use Newfound title to reduce complexity and increase transparency — enjoy a
                  smoother buying experience."
        link="https://homerise.com/title/"
      />
      <TileComponent
        number={6}
        subhead="Get Your Rebate"
        bodyText="Receive your commission rebate at closing – some buyers have gotten back over
                  $20,000. Use it to offset rates, boost your down payment, or improve your ROI."
      />
    </TileGrid>
  </Section>
)

export default HowItWorksSection
